"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _numberFormatter = require("../../../helpers/numberFormatter");
var _HightRiskChartWithLabelComponent = _interopRequireDefault(require("../../HightRiskChart/HightRiskChartWithLabelComponent"));
require("./AccountSummaryComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('wallets-account-summary');
var AccountValueComponent = function AccountValueComponent(_ref) {
  var _ref$isHeader = _ref.isHeader,
    isHeader = _ref$isHeader === void 0 ? false : _ref$isHeader,
    value = _ref.value,
    label = _ref.label,
    highlight = _ref.highlight,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(baseClasses('box'), " ").concat(className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('title')
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(baseClasses(isHeader ? 'header_value' : 'value'), " ").concat(highlight ? baseClasses('highlight') : '')
  }, value), children);
};
var MarginAccountSummaryComponent = function MarginAccountSummaryComponent(_ref2) {
  var baseAsset = _ref2.baseAsset,
    summary = _ref2.summary,
    marginAccount = _ref2.marginAccount,
    getMarginAccountInfo = _ref2.getMarginAccountInfo,
    riskLevel = _ref2.riskLevel;
  var _useTranslation = (0, _reactI18next.useTranslation)('margin'),
    t = _useTranslation.t;
  (0, _react.useEffect)(function () {
    if (marginAccount !== null && marginAccount !== void 0 && marginAccount.AccountId) {
      getMarginAccountInfo(marginAccount.AccountId);
    }
  }, [marginAccount === null || marginAccount === void 0 ? void 0 : marginAccount.AccountId, getMarginAccountInfo]);
  var formatValue = function formatValue(value) {
    return isNaN(value) || value === undefined ? value : (0, _numberFormatter.formatNumberToLocale)(value, baseAsset.DecimalPlaces);
  };
  var baseAssetSymbol = baseAsset.Product;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('component')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('left-section')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('column')
  }, /*#__PURE__*/_react["default"].createElement(AccountValueComponent, {
    label: t('Total Balance ({{asset}})', {
      asset: baseAssetSymbol
    }),
    value: formatValue(summary.Balance),
    isHeader: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('inside_box')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('inside_box_value')
  }, formatValue(summary.MarginBalance)), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('inside_box_title')
  }, t('After Haircuts')))), /*#__PURE__*/_react["default"].createElement(AccountValueComponent, {
    label: t('Margin Equity ({{asset}})', {
      asset: baseAssetSymbol
    }),
    value: formatValue(summary.MarginEquity)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('column')
  }, /*#__PURE__*/_react["default"].createElement(AccountValueComponent, {
    label: t("Today's P&L"),
    value: "".concat(formatValue(summary.PnLPercentage), "%"),
    isHeader: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('inside_box')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('inside_box_value')
  }, " ".concat(formatValue(summary.PnLValue), " ").concat(baseAssetSymbol)))), /*#__PURE__*/_react["default"].createElement(AccountValueComponent, {
    label: t('Maintenance Thres. ({{asset}})', {
      asset: baseAssetSymbol
    }),
    value: formatValue(summary.MaintenanceRequirement)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('column')
  }, /*#__PURE__*/_react["default"].createElement(AccountValueComponent, {
    label: t('Liability ({{asset}})', {
      asset: baseAssetSymbol
    }),
    value: formatValue(summary.Liability),
    isHeader: true
  }), /*#__PURE__*/_react["default"].createElement(AccountValueComponent, {
    label: t('Used Margin ({{asset}})', {
      asset: baseAssetSymbol
    }),
    value: formatValue(summary.UsedMarginValue)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('column')
  }, /*#__PURE__*/_react["default"].createElement(AccountValueComponent, {
    className: "center",
    label: t("Risk Level (0-100)")
  }, (riskLevel === null || riskLevel === void 0 ? void 0 : riskLevel.label) && /*#__PURE__*/_react["default"].createElement(_HightRiskChartWithLabelComponent["default"], {
    level: riskLevel.level,
    riskNumber: riskLevel.riskNumber,
    label: riskLevel.label
  })), /*#__PURE__*/_react["default"].createElement(AccountValueComponent, {
    label: t('Usable Margin ({{asset}})', {
      asset: baseAssetSymbol
    }),
    value: formatValue(summary.UsableMarginValue)
  }))));
};
var _default = exports["default"] = MarginAccountSummaryComponent;